import { useEffect } from 'react'

import { usePrevious } from '@awaze/design-system.utils.react'
import {
  DataLayerEventType,
  DataLayerFactory,
  TmsContextType,
} from '@awaze/mfe-common.contexts.tms'

import { dataLayerErrorHandler } from '@/utils/dataLayerErrorHandler'

interface UseDataLayerEventProps {
  isOpen: boolean
  tms: TmsContextType
}

export const useDataLayerEvent = ({
  isOpen,
  tms,
}: UseDataLayerEventProps): void => {
  const previous = usePrevious(isOpen)
  const hasOpened = previous !== undefined

  const triggerCloseEvent = new DataLayerFactory().getEvent(
    DataLayerEventType.FacetClose,
  )
  const triggerOpenEvent = new DataLayerFactory().getEvent(
    DataLayerEventType.FacetOpen,
  )

  useEffect(() => {
    if (!hasOpened) {
      return
    }

    if (isOpen) {
      triggerOpenEvent.update(tms, {}, dataLayerErrorHandler)
    } else {
      triggerCloseEvent.update(tms, {}, dataLayerErrorHandler)
    }
  }, [isOpen])
}
